import Vue from "vue";
import { PropertiesApi } from "@/apis";

import { convertArrayToObject } from "@/common/helpers";

const state = {
  properties: {},
  propertiesPagination: {},
  propertyTypes: {},
  amenities: {},
  featuredProperties: {},
};

const mutations = {
  setProperties(state, properties) {
    Vue.set(state, "properties", convertArrayToObject(properties, "id"));
  },
  setFeaturedPropertie(state, properties) {
    Vue.set(
      state,
      "featuredProperties",
      convertArrayToObject(properties, "id")
    );
  },
  setPropertiesPagination(state, propertiesPagination) {
    Vue.set(state, "propertiesPagination", propertiesPagination);
  },
  setPropertyDetails(state, propertyDetails) {
    Vue.set(state.properties, propertyDetails.id, propertyDetails);
  },
  setPropertyTypes(state, propertyTypes) {
    propertyTypes = propertyTypes.map((propertyType) => {
      propertyType.fullName =
        propertyType.classification.replace(/\b\w/g, (l) => l.toUpperCase()) +
        " - " +
        propertyType.name;
      return propertyType;
    });

    Vue.set(state, "propertyTypes", convertArrayToObject(propertyTypes, "id"));
  },
  setAmenities(state, amenities) {
    Vue.set(state, "amenities", convertArrayToObject(amenities, "id"));
  },
};

const actions = {
  async getProperties({ commit }, options = {}) {
    commit("setPropertiesPagination", undefined);

    const response = await PropertiesApi.getProperties(
      options.query,
      options.page,
      options.limit
    );
    const properties = response.data.data;
    const propertiesPagination = response.data.pagination;

    commit("setProperties", properties);
    commit("setPropertiesPagination", propertiesPagination);
  },
  async getFeaturedProperties({ commit }, options = {}) {
    const response = await PropertiesApi.getProperties(
      options.query,
      options.page,
      5
    );
    const properties = response.data.data;

    commit("setFeaturedPropertie", properties);
  },
  async getPropertyDetails({ commit }, propertyId) {
    const response = await PropertiesApi.getPropertyByID(propertyId);
    const property = response.data.data;
    commit("setPropertyDetails", property);
  },
  async getPropertyTypes({ commit }) {
    const response = await PropertiesApi.getPropertyTypes();
    const propertyTypes = response.data.data;
    commit("setPropertyTypes", propertyTypes);
  },

  async getAmenities({ commit }, params) {
    const response = await PropertiesApi.getAmenities({
      page: params.page,
      limit: params.itemsPerPage,
    });
    const amenities = response.data.data;
    commit("setAmenities", amenities);
  },
};

const getters = {
  properties(state) {
    return Object.values(state.properties).sort((a, b) =>
      a.id < b.id ? 1 : -1
    );
  },
  featuredProperties(state) {
    return Object.values(state.featuredProperties).sort((a, b) =>
      a.id < b.id ? 1 : -1
    );
  },
  propertiesPagination: (state) => {
    return state.propertiesPagination;
  },
  propertyDetails: (state) => (id) => {
    var temp = state.properties[Number.parseInt(id)];
    if (temp) {
      temp.photos = temp?.photos?.sort((a, b) => (a.order > b.order ? -1 : 1));
    }
    return temp;
  },
  propertyClassifications(state) {
    return Object.values(state.propertyTypes)
      .map((pt) => pt.classification)
      .filter((value, index, self) => self.indexOf(value) === index)
      .map((c) => {
        return {
          key: c,
          name: c.replace(/\b\w/g, (l) => l.toUpperCase()),
        };
      });
  },
  propertyTypes: (state) => {
    return Object.values(state.propertyTypes);
  },
  propertyTypeByID: (state) => (property_type_id) => {
    return state.propertyTypes[property_type_id];
  },
  amenities(state) {
    return Object.values(state.amenities);
  },
  propertyRef(state) {
    const properties = Object.values(state.properties);
    if (properties.length) {
      const newId = parseInt(
        properties[properties.length - 1].ref_no.split("-")[1]
      );
      return `LHP-${newId + 1}`;
    }

    return "LHP-65554";
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
